import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export default makeStyles()((theme) => ({
	checkboxGroup: {
		flex: 1,
		gap: theme.spacing.xxsmall,
	},
	checkboxItem: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
	},
	resultCount: {
		color: theme.palette.neutral[50],
		paddingLeft: theme.spacing.xxsmall,
		lineHeight: '150%',
	},
	hidden: {
		display: 'none',
	},
	toggleStyles: {
		'&&': {
			padding: 0,
		},
	},
}));
